import React from "react";
import { PlanAccountBalanceContainer } from "../../../containers";

const PlanAccountBalance = (props) => {
  return <PlanAccountBalanceContainer {...props} />;
};

export default PlanAccountBalance;
